import React, { Component } from 'react';
import { connect } from "react-redux";
import { Modal, Button, Row, Col, Container } from 'react-bootstrap'

const mapStateToProps = state => {
  return {
    currentUser: state.currentUserReducer
  };
}

const matchDispatchToProps = (dispatch) => {
  return {
  }
}

class EfileConfirmation extends Component {

   handleYesClick = (event) => {
      if (event) {
         event.preventDefault();
      }
      this.props.cancelConfirmation();
      this.props.proceedConfirmation();
   }

   handleNoClick = (event) => {
      if (event) {
         event.preventDefault();
      }
      this.props.cancelConfirmation();
   }

   isNonZeroCharge = (value) => {
      return (value !== '') && (value !== '0') && (value !== '0.00');
   }

   render() {
      const hasDocumentCharge = this.props.showCharges && this.props.firstPageCharge && this.props.firstPageCharge !== '' ? true : false;
      const hasAdditionalPagesCharge = this.props.showCharges && this.props.additionalPagesCharge && this.props.additionalPagesCharge !== '' ? true : false;
      const hasSurcharge = this.props.showCharges && this.props.surcharge && this.isNonZeroCharge(this.props.surcharge) ? true : false;
      const hasTotalCharge = this.props.showCharges && this.props.totalCharge && this.props.totalCharge !== '' ? true : false;
    
      let documentChargeRow = <></>
      if (hasDocumentCharge) {
         documentChargeRow = <Row><Col lg={1}></Col><Col lg={5}>Document charge:</Col><Col lg={5} style={{textAlign: 'right'}}>${this.props.firstPageCharge}</Col><Col lg={1}></Col></Row>
      }

      let additionalPagesChargeRow = <></>
      if (hasAdditionalPagesCharge) {
         additionalPagesChargeRow = <Row><Col lg={1}></Col><Col lg={5}>Additional pages:</Col><Col lg={5} style={{textAlign: 'right'}}>${this.props.additionalPagesCharge}</Col><Col lg={1}></Col></Row>
      }

      let surchargeRow = <></>
      if (hasSurcharge) {
         if (this.props.paymentMethod === 'CREDIT_CARD') {
            surchargeRow = <Row><Col lg={1}></Col><Col lg={5}>Credit card surcharge:</Col><Col lg={5} style={{textAlign: 'end'}}>${this.props.surcharge}</Col><Col lg={1}></Col></Row>
         } else {
            surchargeRow = <Row><Col lg={1}></Col><Col lg={5}>Payment surcharge:</Col><Col lg={5} style={{textAlign: 'end'}}>${this.props.surcharge}</Col><Col lg={1}></Col></Row>
         }
      }

      let totalChargeRow = <></>
      if (hasTotalCharge) {
         totalChargeRow = <Row style={{fontWeight: 'bold'}}><Col lg={1}></Col><Col lg={5}>Total to be charged:</Col><Col lg={5} style={{textAlign: 'right'}}>${this.props.totalCharge}</Col><Col lg={1}></Col></Row>
      }

      let anyChargeRows = hasDocumentCharge || hasAdditionalPagesCharge || hasSurcharge || hasTotalCharge;

      let modalTitle = '';
      if (this.props.paymentMethod === 'CREDIT_CARD') {
         modalTitle = 'Continue to Payment?';
      } else {
         modalTitle = 'Continue?';
      }

      return (
         <Modal show={this.props.show} onHide={this.handleNoClick} size="lg" centered>
            <Modal.Header closeButton >
               <Modal.Title style={{color: '#3674AB'}}>{modalTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{borderTop: '2px solid black', borderBottom: '2px solid black', background: '#3674AB', color: 'white',  fontSize: 20}}>
            <Container fluid="true" className='h-100'>
               <Row><Col lg={1}></Col><Col lg={5}>Number of document pages:</Col><Col lg={5} style={{textAlign: 'right'}}>{this.props.numberOfPages}</Col><Col lg={1}></Col></Row>
               { anyChargeRows && 
                  <Row>&nbsp;</Row>
               }
               {documentChargeRow}
               {additionalPagesChargeRow}
               {surchargeRow}
               {hasTotalCharge &&
                  <>
                     <Row ><Col lg={1}></Col><Col lg={10} style={{textAlign: 'right'}}><hr style={{borderColor: 'white'}}/></Col><Col lg={1}></Col></Row>
                     {totalChargeRow}
                     <Row ><Col lg={1}></Col><Col lg={10} style={{textAlign: 'right'}}><hr style={{borderColor: 'white'}}/></Col><Col lg={1}></Col></Row>
                  </>
               }
              </Container>
              
            </Modal.Body>
            <Modal.Footer>
               <Button variant="primary" onClick={this.handleYesClick}>Yes</Button>
               <Button variant="secondary" onClick={this.handleNoClick}>No</Button>
            </Modal.Footer>
         </Modal>
      )
   }

}

export default connect(mapStateToProps, matchDispatchToProps)(EfileConfirmation);